import React, { useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as ChevronIcon } from "../../assets/left-chevron-icon.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus-icon.svg";
import clsx from "clsx";

interface AccordionItemProps {
  accordionHeaderClassName?: string;
  accordionInnerContentClassName?: string;
  accordionItemClassName?:string;
  title: React.ReactNode;
  children: React.ReactNode;
  backgroundColor?: "white" | "gray";
  iconType?: "chevron" | "plus";
  isPaddingDisable?: "noPadding" | "";
  isExpanded?: boolean;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  accordionHeaderClassName,
  accordionInnerContentClassName,
  accordionItemClassName,
  title,
  children,
  backgroundColor = "white",
  iconType = "chevron",
  isPaddingDisable = "",
  isExpanded=false
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(isExpanded);

  const toggleAccordion = () => setIsOpen(!isOpen);

  return (
    <div className={clsx(styles.accordionItem, accordionItemClassName, `${isOpen ? styles.accordionItemOpen : ""}`)}>
      <button
        className={clsx(
          styles.accordionHeader,
          accordionHeaderClassName,
          "fontWeightBold fontSizeSm fontColorBlack",
          backgroundColor === "gray" ? "bgGray" : "bgWhite"
        )}
        onClick={toggleAccordion}
        aria-expanded={isOpen}
      >
        {title}
        <span
          className={clsx(
            styles.icon,
            isOpen ? styles.iconOpen : styles.iconClosed,
            iconType === "plus" ? styles.plusIcon : styles.chevronIcon
          )}
        >
          {iconType === "plus" ? <PlusIcon /> : <ChevronIcon />}
        </span>
      </button>
      <div
        className={styles.accordionContent}
        style={{
          maxHeight: isOpen ? "100%" : "0",
          overflow: "hidden",
          // transition: "all 0.3s ease-in-out",
        }}
      >
        <div
          className={clsx(
            styles.accordionInnerContent,
            accordionInnerContentClassName,
            backgroundColor === "gray" ? "bgGray" : "bgWhite",
            isPaddingDisable === "noPadding" && styles.noPadding
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
